import './App.scss'

import React, { Component } from 'react'
import { render } from 'react-dom'
import StateReport from "./Components/StateReport";

class StateApp extends Component {
  render() {
    return <StateReport/>
  }
}

render(<StateApp/>, document.querySelector('#stateReport'));

export default StateApp;
